import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import { Icon } from './index';
var SkholeIcon13 = Icon( /*#__PURE__*/_jsx("svg", {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 40 40",
  style: {
    enableBackground: 'new 0 0 40 40'
  },
  xmlSpace: "preserve"
}, void 0, /*#__PURE__*/_jsx("g", {}, void 0, /*#__PURE__*/_jsx("path", {
  className: "st1",
  d: "M31,7.7h-0.6V5.2c0-0.7-0.6-1.2-1.2-1.2H10.8c-0.7,0-1.2,0.6-1.2,1.2v2.4H9c-0.7,0-1.2,0.6-1.2,1.2v3.7 c0,0.6,0.5,1.2,1.1,1.2l0.7,16.4c0,3.2,2.6,5.8,5.8,5.8h9.3c3.2,0,5.8-2.6,5.8-5.8L31,13.9h0c0.7,0,1.2-0.6,1.2-1.2V8.9 C32.2,8.2,31.7,7.7,31,7.7z M10.2,10.2h0.6h18.3h0.6v1.2H10.2V10.2z M12.1,6.5h15.8v1.2H12.1V6.5z M27.9,30.2 c0,1.8-1.5,3.3-3.3,3.3h-9.3c-1.8,0-3.3-1.5-3.3-3.4l-0.7-16.3h17.1L27.9,30.2z"
}), /*#__PURE__*/_jsx("path", {
  className: "st1",
  d: "M15.4,28.6c0.7,0,1.2-0.6,1.2-1.2v-9.9c0-0.7-0.6-1.2-1.2-1.2s-1.2,0.6-1.2,1.2v9.9 C14.2,28.1,14.7,28.6,15.4,28.6z"
}), /*#__PURE__*/_jsx("path", {
  className: "st1",
  d: "M20,28.6c0.7,0,1.2-0.6,1.2-1.2v-9.9c0-0.7-0.6-1.2-1.2-1.2s-1.2,0.6-1.2,1.2v9.9C18.8,28.1,19.3,28.6,20,28.6 z"
}), /*#__PURE__*/_jsx("path", {
  className: "st1",
  d: "M24.6,28.6c0.7,0,1.2-0.6,1.2-1.2v-9.9c0-0.7-0.6-1.2-1.2-1.2s-1.2,0.6-1.2,1.2v9.9 C23.3,28.1,23.9,28.6,24.6,28.6z"
}))));
export default SkholeIcon13;